import { abbreviateNumber } from 'src/utils/number-format'

export function convertCamelCaseToPhrase(value: string) {
  const splitWords = value.replace(/([A-Z])/g, ' $1')
  return splitWords.charAt(0).toUpperCase() + splitWords.slice(1)
}

export const prettyBucketName = (attribute: string, input: string) => {
  let base = input.toLowerCase().replace(`${attribute.toLocaleLowerCase()}_`, '').replace(/_/g, ' ')
  base = base.replace('less than', '-')
  base = base.replace('more than', '+')
  base = base.replace('over', '+')
  const words = base.split(' ')
  const formated = words.map((w, index) => {
    const number = parseFloat(w)
    if (!isNaN(number)) {
      const postfix = index !== words.length - 1 ? '-' : ''
      return `${abbreviateNumber(number)}${postfix}`
    }
    const postfix = index !== words.length - 1 ? ' ' : ''
    return `${w.charAt(0).toUpperCase()}${w.slice(1)}${postfix}`
  })
  return formated.join('')
}

export const prettyAttributeName = (attribute: string) => {
  const base = attribute.toLowerCase()
  return `${base.charAt(0).toUpperCase()}${base.slice(1)}`
}

export const capitalizeFirstLetter = (input: string) => {
  const base = input.toLowerCase()
  return `${base.charAt(0).toUpperCase()}${base.slice(1)}`
}

export const capitalizeAllFirstLetter = (input?: string) => {
  if (!input) {
    return ''
  }
  return input
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ')
}

export const prettyPlaceType = (input: string) => {
  return (input ?? '')
    .split('_')
    .map((x) => capitalizeFirstLetter(x))
    .join(' ')
}

export const toMixedChar = (input: string) => {
  return (input ?? '')
    .split(' ')
    .map((s) => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
    .join(' ')
}

export const camelToSnakeCase = (input: string) => {
  return input.replace(/[A-Z]/g, (c) => {
    return '_' + c.toLowerCase()
  })
}
